import React from 'react';
import { styles } from './InstallOffer.css';
import { Icon } from '@jbhi-fi/lanyard-ui/components/Icon';

interface InstallOfferProps {
  title?: string;
  shortDescription?: string;
  description?: string;
}

const InstallOffer = ({ title, shortDescription, description }: InstallOfferProps) => {
  return (
    <div data-testid="install-offer" className={styles.container}>
      <Icon name="Tag" className={styles.icon} />
      <div>
        {!!title && <p className={styles.heading}>{title}</p>}
        {!!shortDescription && <div className={styles.shortDescription}>{shortDescription}</div>}
        {!!description && <div className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />}
      </div>
    </div>
  );
};

export { InstallOffer };
